<a [action]="model.onClick" [ngClass]="model.theme" [ngStyle]="model.style">{{ model.text }}</a>
